import styled from 'styled-components';

import { BigButton } from '../Buttons';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  width: 100%;
`;

export const Text = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 19.2px;
`;

export const TextInfo = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 19.2px;
  margin: 0;
`;

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 8px 0;
`;

export const LinkContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Link = styled.a`
  font-size: 16px;
  font-weight: 500;
  line-height: 19.2px;
  color: #FF7400;
  text-decoration: underline;
  transition: color 0.2s ease;
  
  &:hover {
    color: #e66600;
    text-decoration: underline;
  }
  
  &:focus {
    outline: 2px solid #FF7400;
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const BtnContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;

export const CutomBtn = styled(BigButton)`
  width: auto;
`;
